import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function StudentSurprise({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 143.996"
      xmlSpace="preserve"
    >
      <g id="hébé">
        <g id="surprise_1_">
          <g>
            <ellipse fill="#A6E3F9" cx="72" cy="71.996" rx="72" ry="71.998" />
            <g>
              <defs>
                <ellipse id="SVGID_5_" cx="72" cy="72" rx="72" ry="71.998" />
              </defs>
              <clipPath id="SVGID_2_">
                <use xlinkHref="#SVGID_5_" overflow="visible" />
              </clipPath>
              <g clipPath="url(#SVGID_2_)">
                <path fill="#42291C" d="M90.024,109.393c-0.511-0.253-3.9-1.057-4.485-1.037l-51.122,0.784 c-3.495,0.122-7.023,0.119-9.476,2.222l-0.332,0.183c-1.97-4.843-4.999-8.726-4.578-16.98 c0.612-12.011,11.926-11.539,12.537-23.55c0.079-1.541-0.102-2.896-0.464-4.108c-1.189-1.586-2.209-3.261-3.024-5.007 c0,0,0,0-0.012-0.009c-0.136-0.303-0.271-0.597-0.396-0.9c-1.314-3.083-2.016-6.38-2.016-9.801 c0-17.063,17.588-30.902,39.289-30.902c21.688,0,39.277,13.838,39.277,30.902c0,3.421-0.702,6.718-2.016,9.801 c-0.125,0.303-0.261,0.615-0.408,0.918c-0.815,1.738-1.824,3.404-3.013,4.981c-0.373,1.212-0.554,2.575-0.476,4.126 c0.612,12.011,11.937,11.539,12.549,23.55c0.415,8.145-9.062,21.972-11.034,26.699l-2.439-3.713 C95.081,115.215,96.223,112.47,90.024,109.393z" />
                <path fill="#FFE500" d="M77.524,110.822c-6.343,4.166-8.107,12.686-3.941,19.029c0.334,0.508,0.705,0.975,1.091,1.424 l-0.011,0.008l37.834,43.968l15.907-12.005l-31.85-48.484C92.387,108.419,83.867,106.655,77.524,110.822z" />
                <circle fill="#FFE500" cx="84.684" cy="122.462" r="14.136" />
                <path fill="#FFE500" d="M98.744,123.115l-3.659,79.075H44.518l-20.896-83.042c-1.382-5.493,2.771-10.822,8.436-10.822h52.565 C92.686,108.326,99.117,115.06,98.744,123.115z" />
                <path fill="#FFE500" d="M42.027,111.969c-5.795-5.231-14.733-4.775-19.966,1.02c-0.419,0.464-0.788,0.955-1.134,1.455 l-0.011-0.009l-33.941,49.079L3.057,176.23l39.991-44.296C48.279,126.139,47.822,117.2,42.027,111.969z" />
                <path fill="#283042" d="M101.061,58.588c-0.012,0.009-0.012,0.009-0.012,0.009" />
                <path fill="#AA7852" d="M53.694,110.228c1.065,6.52,7.213,10.941,13.733,9.876s10.942-7.213,9.877-13.733 c-1.065-6.52-7.213-10.941-13.733-9.876C57.051,97.56,52.629,103.708,53.694,110.228z" />
                <polygon fill="#AA7852" points="77.304,106.371 53.694,110.228 48.945,81.156 49.638,81.043 72.555,77.3" />
                <path fill="#AA7852" d="M63.968,28.386l-1.836,0.3C50.412,30.6,42.463,41.652,44.377,53.372l6.529,39.974l22.229-3.631 c11.163-1.823,18.735-12.351,16.911-23.514l-3.528-21.597C84.771,33.898,74.674,26.637,63.968,28.386z" />
                <path fill="#0E0E11" d="M77.352,55.207c-0.219,0-0.405-0.169-0.422-0.391c-0.017-0.233,0.157-0.437,0.39-0.455l5.737-0.436 c0.237-0.022,0.437,0.157,0.455,0.39c0.017,0.233-0.157,0.437-0.39,0.455l-5.737,0.436 C77.375,55.207,77.363,55.207,77.352,55.207z" />
                <path fill="#0E0E11" d="M62.525,55.843c-0.223,0-0.409-0.173-0.423-0.398c-0.014-0.234,0.164-0.434,0.397-0.448l6.227-0.378 c0.247-0.01,0.434,0.164,0.448,0.397c0.014,0.234-0.164,0.434-0.397,0.448l-6.227,0.378 C62.541,55.843,62.533,55.843,62.525,55.843z" />
                <path fill="#AA7852" d="M45.051,69.451l4.88-0.793l-0.791-4.87c-0.437-2.689-2.976-4.514-5.671-4.076l0,0 c-2.695,0.438-4.526,2.974-4.089,5.663l0,0C39.817,68.064,42.356,69.889,45.051,69.451z" />

                <ellipse transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.3029 3.7598)" fill="#0E0E11" cx="65.872" cy="61.199" rx="1.621" ry="2.092" />

                <ellipse transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.2379 4.5359)" fill="#0E0E11" cx="79.844" cy="60.42" rx="1.621" ry="2.092" />
              </g>
            </g>
          </g>
          <path fill="#42291C" d="M60.667,53.007c-4.959,4.386-7.99,6.606-14.252,6.796c0,0-1.128-0.05-1.128-0.05l-2.255-13.991 c-1.588-9.305,5.56-17.808,15-17.843l15.444-1.586c5.562-0.571,10.597,3.313,11.457,8.837l1.168,7.493 C77.643,43.317,67.022,47.387,60.667,53.007z" />
          <ellipse fill="#FFFFFF" cx="75.96" cy="76.852" rx="1.841" ry="2.47" />
        </g>
      </g>
      <g id="pistis" />
      <g id="ponos" />
      <g id="TITLE" />
    </svg>
  );
}

export default StudentSurprise;
